import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ICommonPopupsProps, Popup } from '@gem/popups';
import { Switch } from '@gem/ui-kit';

import { IDevToolsPopupParams, useDevToolsPopupPresenter } from './DevToolsPopup.presenter';
import styles from './DevToolsPopup.styles.m.css';

export const DevToolsPopup: FC<ICommonPopupsProps<IDevToolsPopupParams>> = observer((props) => {
  const presenter = useDevToolsPopupPresenter(props);

  return (
    <Popup
      className={styles.popup}
      title="Dev tools"
      isOpened={true}
      onClose={presenter.onClosePopup}
    >
      <div className={classNames(styles.flexColumn, styles.padding32, styles.gap16)}>
        <div className={classNames(styles.flexRow, styles.flexSpaceBetween)}>
          <div className={classNames(styles.flexRow, styles.gap48)}>
            <div className={classNames(styles.flexRow, styles.gap16)}>
              <label className={classNames(styles.flexRow, styles.gap8)}>
                <span>Show logs</span>
                <Switch
                  className={styles.switch}
                  isChecked={presenter.isLogEnabled}
                  onChange={presenter.onLogEnabledChange}
                  isDisabled={!presenter.isShowLogSwitch}
                />
              </label>
            </div>
          </div>
        </div>
        <div className={styles.divider} />
      </div>
    </Popup>
  );
});
